import axios from '../../axios';

export default async function deleteUserRequest(): Promise<void> {
  const response = await axios.delete<void>(
    `${process.env.REACT_APP_BASE_URL}/users`
  );
  return response.data;
}
